module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adddingdan"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "daohang"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "color": "#2d8cf0",
      "font-family": "'微软雅黑'"
    },
    on: {
      "click": _vm.tiaozhuan
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-home"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.language.shouye))], 1), _vm._v(">\n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "font-family": "'微软雅黑'"
    }
  }, [_vm._v(_vm._s(_vm.language.jiagongdingdanshenqing))])]), _vm._v(" "), _c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "iptc"
  }, [_c('div', {
    staticClass: "iptlis"
  }, [_c('Icon', {
    staticClass: "ico",
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "iptli",
    attrs: {
      "type": "text",
      "placeholder": _vm.language.chaxunqingdianjiwo
    },
    on: {
      "click": function($event) {
        _vm.srechEve()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "numEve"
  }, [_c('div', {
    staticClass: "numlitter"
  }, [_vm._v(_vm._s(_vm.language.gong) + _vm._s(_vm.numnum) + _vm._s(_vm.language.tiao))])])], 1)])])]), _vm._v(" "), _c('modal', {
    staticClass: "serchlist",
    attrs: {
      "width": "86%",
      "styles": {
        top: '60px',
        left: '100px'
      }
    },
    model: {
      value: (_vm.raval),
      callback: function($$v) {
        _vm.raval = $$v
      },
      expression: "raval"
    }
  }, [_c('div', {
    staticClass: "pz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpinzhong),
      callback: function($$v) {
        _vm.numpinzhong = $$v
      },
      expression: "numpinzhong"
    }
  }, _vm._l((_vm.customer), function(item) {
    return _c('Option', {
      attrs: {
        "value": item.tuTradeUnitId
      }
    }, [_vm._v(_vm._s(item.tuTradeUnitName))])
  })), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.language.shouhuokehu))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ph"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpaihao),
      callback: function($$v) {
        _vm.numpaihao = $$v
      },
      expression: "numpaihao"
    }
  }, _vm._l((_vm.selectDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.language.pinzhong))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chxz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.cpyl),
      callback: function($$v) {
        _vm.cpyl = $$v
      },
      expression: "cpyl"
    }
  }, _vm._l((_vm.shopDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.language.paihao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chanpinyuanliao"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.cunhuo),
      callback: function($$v) {
        _vm.cunhuo = $$v
      },
      expression: "cunhuo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paihaos"
  }, [_vm._v(_vm._s(_vm.language.yuanliaoguige))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kunbaos"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpaihaos),
      callback: function($$v) {
        _vm.numpaihaos = $$v
      },
      expression: "numpaihaos"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paihaos"
  }, [_vm._v(_vm._s(_vm.language.chengpinguige))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kunbaos"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.exposedNum),
      callback: function($$v) {
        _vm.exposedNum = $$v
      },
      expression: "exposedNum"
    }
  }, [_c('Option', {
    attrs: {
      "lable": "10",
      "value": "10"
    }
  }, [_vm._v("Exposed")]), _vm._v(" "), _c('Option', {
    attrs: {
      "lable": "20",
      "value": "20"
    }
  }, [_vm._v("Unexposed")])], 1), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.language.neiwaiban))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(249,249,249)",
      "height": "120px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "chaxun",
    on: {
      "click": function($event) {
        _vm.chaxun()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.chaxun))]), _vm._v(" "), _c('div', {
    staticClass: "chongzhi",
    on: {
      "click": function($event) {
        _vm.chongzhis()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.chongzhi))])])]), _vm._v(" "), _c('div', {
    staticClass: "adddingdan_change_height"
  }, [_c('div', {
    attrs: {
      "animated": false
    },
    model: {
      value: (_vm.nameTab),
      callback: function($$v) {
        _vm.nameTab = $$v
      },
      expression: "nameTab"
    }
  }, _vm._l((_vm.templateList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "add_ding_dan_sq"
    }, [_c('div', {
      staticClass: "add_ding_dan_shen_qing",
      class: {
        bgc: _vm.bgc === index
      },
      on: {
        "click": function($event) {
          _vm.showDingDanTable(item, index)
        }
      }
    }, [_c('p', {
      staticClass: "customerName"
    }, [_vm._v(_vm._s(item.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "add_ding_dan_p_top"
    }, [_c('p', {
      staticClass: "add_ding_dan_p_span_left"
    }, [_c('span', [_vm._v(_vm._s(item.categoryCode))]), _c('Poptip', {
      attrs: {
        "trigger": "hover",
        "title": item.shopsign
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "more_text"
    }, [_vm._v(_vm._s(item.shopsign))]), _vm._v(" "), _c('p', {
      staticClass: "add_ding_dan_p_span_left"
    }, [_c('span', [_vm._v(_vm._s(item.specification))])])]), _vm._v(" "), _c('div', {
      staticClass: "add_ding_dan_shu_liang"
    }, [_vm._v("\n                ("), _c('span', {
      staticClass: "add_ding_dan_shu_liang_margin"
    }, [_vm._v(_vm._s(item.totalprodCount))]), _c('span', [_vm._v(_vm._s(item.totalprodWeight))]), _vm._v("Kg)\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "add_ding_dan_jian_tou"
    }, [_c('Icon', {
      attrs: {
        "type": "arrow-down-a"
      }
    })], 1), _vm._v(" "), (item.productList) ? _c('div', {
      staticClass: "add_ding_dan_shen_qing_list"
    }, _vm._l((item.productList), function(items, indexs) {
      return _c('p', {
        key: indexs
      }, [_c('span', {
        staticClass: "add_ding_dan_shen_qing_list_spes"
      }, [_vm._v(_vm._s(items.spes))]), _c('span', {
        staticClass: "add_ding_dan_shen_qing_num"
      }, [_vm._v(_vm._s(items.firstNumbers))]), _c('span', {
        staticClass: "add_ding_dan_shen_qing_weight"
      }, [_vm._v("( " + _vm._s(items.allSecondQty) + "  /  " + _vm._s(items.allPrimaryQty) + "KG )")])])
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "add_ding_dan_jian_shu_liang"
    }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("numValue")(item)))])])]), _vm._v(" "), (index === _vm.addDingDanShenQingTable) ? _c('div', {
      staticClass: "add_ding_dan_shen_qing_table",
      attrs: {
        "border": ""
      }
    }, [_c('Table', {
      attrs: {
        "columns": _vm.columns1,
        "data": _vm.data1,
        "border": ""
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.moredata),
        expression: "moredata"
      }],
      staticClass: "add_ding_dan_shen_qing_table_more_data",
      on: {
        "click": function($event) {
          _vm.addMoreShenQingData(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.language.jiazaigengduo) + "\n            ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.moredata),
        expression: "!moredata"
      }],
      staticClass: "add_ding_dan_shen_qing_table_more_data",
      on: {
        "click": function($event) {
          _vm.addMoreShenQingData(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.language.jiazaiwanbi) + "\n            ")])], 1) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "bootBanner"
  }, [_c('p', {
    staticClass: "liang"
  }, [_c('span', [_c('span', {
    staticClass: "tihuoButton",
    on: {
      "click": function($event) {
        _vm.showHandMove(1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-compose"
    }
  }), _vm._v(_vm._s(_vm.language.shoutianjiagong))], 1)]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "shopButton",
    on: {
      "click": _vm.showSubmitCar
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cart"
    }
  }), _vm._v(_vm._s(_vm.language.gouwuche))], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitCar),
      expression: "submitCar"
    }],
    staticClass: "wait_submit_car"
  }, [_c('div', {
    staticClass: "wait_submit_car_title",
    attrs: {
      "border": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.language.daitijiaojiagongshenqing))]), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.closeSubmitCar
    }
  }, [_c('span'), _c('Icon', {
    staticClass: "closeShoping",
    attrs: {
      "type": "ios-close-outline"
    }
  }), _vm._v(_vm._s(_vm.language.guanbi))], 1)]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns2,
      "data": _vm.data2,
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit_add_car"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.submitAddCar()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.quanbutijiao))]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.removeSubmitAddCar()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.qingkonggouwuche))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handMove),
      expression: "handMove"
    }],
    staticClass: "hand_move_submit_car"
  }, [_c('div', {
    staticClass: "hand_move_submit_car_title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.language.jiagongdingdanshenqing))]), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.closehandMoveCar
    }
  }, [_c('span'), _vm._v(_vm._s(_vm.language.fanhui))])]), _vm._v(" "), _c('div', {
    staticClass: "hand_move_title_car"
  }, [_c('p', [_vm._v(_vm._s(_vm.language.yuanliaochengpinxuanze))])]), _vm._v(" "), _c('div', {
    staticClass: "hand_move_search_material"
  }, [_c('p', [_vm._v("1." + _vm._s(_vm.language.qingxuanzeyuanliao))]), _vm._v(" "), _c('div', {
    staticClass: "hand_move_search_material_news"
  }, [_c('div', {
    staticClass: "hand_move_search_material_condition"
  }, [_c('ul', [_c('li', [_c('label', [_vm._v(_vm._s(_vm.language.pinzhong))]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpinzhong),
      callback: function($$v) {
        _vm.numpinzhong = $$v
      },
      expression: "numpinzhong"
    }
  }, _vm._l((_vm.selectDatta), function(item) {
    return _c('Option', {
      key: item,
      staticStyle: {
        "width": "150px",
        "height": "40px",
        "line-height": "30px"
      },
      attrs: {
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.language.paihao))]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpaihao),
      callback: function($$v) {
        _vm.numpaihao = $$v
      },
      expression: "numpaihao"
    }
  }, _vm._l((_vm.shopDatta), function(item) {
    return _c('Option', {
      key: item,
      staticStyle: {
        "width": "150px",
        "height": "40px",
        "line-height": "30px"
      },
      attrs: {
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('li', [_c('label', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.language.kunbaohao))]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.kunbaohao),
      callback: function($$v) {
        _vm.kunbaohao = $$v
      },
      expression: "kunbaohao"
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.language.cangku))]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numcangku),
      callback: function($$v) {
        _vm.numcangku = $$v
      },
      expression: "numcangku"
    }
  }, _vm._l((_vm.wareDatta), function(item) {
    return _c('Option', {
      key: item,
      staticStyle: {
        "width": "150px",
        "height": "40px",
        "line-height": "30px"
      },
      attrs: {
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.language.hou))]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.handMoveHeight),
      callback: function($$v) {
        _vm.handMoveHeight = $$v
      },
      expression: "handMoveHeight"
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.language.kuan))]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.handMoveWide),
      callback: function($$v) {
        _vm.handMoveWide = $$v
      },
      expression: "handMoveWide"
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v(_vm._s(_vm.language.chang))]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.handMoveWidth),
      callback: function($$v) {
        _vm.handMoveWidth = $$v
      },
      expression: "handMoveWidth"
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.language.mujuanhao))]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.mujuantiaojian),
      callback: function($$v) {
        _vm.mujuantiaojian = $$v
      },
      expression: "mujuantiaojian"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.showHandMove(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.language.chayuanliao))])]), _vm._v(" "), _c('div', {
    staticClass: "hand_move_search_material_table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns3,
      "data": _vm.data3,
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handMoveDataThree),
      expression: "handMoveDataThree"
    }],
    staticClass: "hand_move_search_material_table_more",
    on: {
      "click": _vm.handMoveDataThreeMore
    }
  }, [_vm._v(_vm._s(_vm.language.jiazaigengduo))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.handMoveDataThree),
      expression: "!handMoveDataThree"
    }],
    staticClass: "hand_move_search_material_table_more",
    on: {
      "click": _vm.handMoveDataThreeMore
    }
  }, [_vm._v(_vm._s(_vm.language.jiazaiwanbi))])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handMoveSearchMaterial),
      expression: "handMoveSearchMaterial"
    }]
  }, [_c('div', {
    staticClass: "hand_move_maintenance_products"
  }, [_c('p', [_vm._v("2." + _vm._s(_vm.language.weihujiagongchengpin))]), _vm._v(" "), _c('div', {
    staticClass: "hand_move_maintenance_products_tabs"
  }, [_c('div', {
    staticClass: "hand_move_maintenance_products_news"
  }, [_c('div', {
    staticClass: "hand_move_maintenance_products_table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns4,
      "data": _vm.data4,
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hand_move_products_computed_table"
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand_move_submit_add_car"
  }, [_c('p', [_c('button', {
    attrs: {
      "id": "submitTemporaryAddCar",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitTemporaryAddCar
    }
  }, [_vm._v(_vm._s(_vm.language.tijiaoshenqing))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f8377a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/addDingDan.vue
// module id = 918
// module chunks = 1